import React, { useContext, useEffect, useState } from "react";
import App, { MainContext } from "../App";
import { CharacterState } from "../controllers/characters";

import config from "../worldConfig";

const { WORLD_SIZE, POP_FACTOR } = config;

function Families() {
  const { appState: context, setAppState: setContext } =
    useContext(MainContext);

  const groupByFamily = (
    families: { [key: string]: number },
    c: CharacterState
  ): { [key: string]: number } => {
    return {
      ...families,
      [`${c.lastname}`]: families[c.lastname] ? families[c.lastname] + 1 : 1,
    };
  };

  const familiesLiving = context.world.characters.reduce(groupByFamily, {});

  const sortAlpha = (a: [string, number], b: [string, number]) =>
    a[0].localeCompare(b[0]);
  const sortNum = (a: [string, number], b: [string, number]) => b[1] - a[1];

  const familiesElem = Object.entries(familiesLiving)
    .sort(sortNum)
    .map((f) => <div key={`${f[0]}-size`}>{`${f[0]}: ${f[1]}`}</div>);

  return <div className="Families">{familiesElem}</div>;
}

export default Families;
